import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import mainBanner from '@/assets/img/banner/information.jpg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import TabList from '@/components/common/Tab/TabList/TabList';
import InformationCommunity from '@/components/Information/InformationCommunity/InformationCommunity';
import InformationCommunityForm from '@/components/Information/InformationCommunity/InformationCommunityForm/InformationCommunityForm';
import InformationNotice from '@/components/Information/InformationNotice/InformationNotice.tsx';

const menuList = ['공지사항', '자유게시판'];

const Membership = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const params = location.state?.menu ?? menuList[0];
	const stepParams = location.state?.step;

	const handleSetMenu = (menu: string) => {
		navigate('/information', { state: { menu: menu } });
	};

	return (
		<main>
			<SubBanner subTitle="Information" title="자료실" img={mainBanner} />
			<TabList menuList={menuList} menuKey={params} onListClick={handleSetMenu} />
			{params === menuList[0] && <InformationNotice />}
			{params === menuList[1] && stepParams !== '등록' && stepParams !== '수정' && <InformationCommunity />}
			{params === menuList[1] && (stepParams === '등록' || stepParams === '수정') && <InformationCommunityForm />}
		</main>
	);
};

export default Membership;
